import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'signalProperties',
    standalone: false
})
export class SignalPropertiesPipe implements PipeTransform {

    signalMapper = [
        // temperature
        {name: 'WNAC1_IntlTmp_mag_f', unit: '°C', label: 'Nacelle Temp'},
        {name: 'WNAC1_CtrCabTmp_mag_f', unit: '°C', label: 'Nacelle Cabinet Temp'},
        {name: 'WROT1_CtrCabTmp_mag_f', unit: '°C', label: 'Rotor Hub Temp'},
        {name: 'WROT1_HubTmp_mag_f', unit: '°C', label: 'Rotor Hub Cabinet Temp'},
        {name: 'WROT1_PtHyOilTmp_mag_f', unit: '°C', label: 'Pitch Oil Temp'},
        {name: 'WGEN1_GnTmpRtr_mag_f', unit: '°C', label: 'Gen Rotor Temp'},
        {name: 'WGEN1_GnTmpSta_mag_f', unit: '°C', label: 'Gen Stator Temp'},
        {name: 'WGEN1_GnTmpInlet_mag_f', unit: '°C', label: 'Gen Cooling in Temp'},
        {name: 'WGEN1_GnTmpOutlet_mag_f', unit: '°C', label: 'Gen Cooling out Temp'},
        {name: 'WGEN1_GnTmpBrg1_mag_f', unit: '°C', label: 'Gen Bearing 1 Temp'},
        {name: 'WGEN1_GnTmpBrg2_mag_f', unit: '°C', label: 'Gen Bearing 2 Temp'},
        {name: 'WGEN1_GnTmpPhase1_mag_f', unit: '°C', label: 'Gen Phase 1 Temp'},
        {name: 'WGEN1_GnTmpPhase2_mag_f', unit: '°C', label: 'Gen Phase 2 Temp'},
        {name: 'WGEN1_GnTmpPhase3_mag_f', unit: '°C', label: 'Gen Phase 3 Temp'},
        {name: 'WGEN1_GnTmpSlpRing1_mag_f', unit: '°C', label: 'Slipring 1 Temp'},
        {name: 'WGEN1_GnTmpSlpRing2_mag_f', unit: '°C', label: 'Slipring 2 Temp'},
        {name: 'WTRM1_TrmTmpGbxOil_mag_f', unit: '°C', label: 'Gbx Oil Temp'},
        {name: 'WTRM1_TrmTmpGbxBrg1_mag_f', unit: '°C', label: 'Gbx Bearing 1 Oil Temp'},
        {name: 'WTRM1_TrmTmpGbxBrg2_mag_f', unit: '°C', label: 'Gbx Bearing 2 Oil Temp'},
        {name: 'WTRM1_TrmTmpGbxBrg3_mag_f', unit: '°C', label: 'Gbx Bearing 3 Oil Temp'},
        {name: 'WTRM1_TrmTmpShfBrg1_mag_f', unit: '°C', label: 'Shaft Bearing 1'},
        {name: 'WTRM1_TrmTmpShfBrg2_mag_f', unit: '°C', label: 'Shaft Bearing 2'},
        {name: 'WTRF1_TrfTmpPhase1_mag_f', unit: '°C', label: 'Trafo Phase 1'},
        {name: 'WTRF1_TrfTmpPhase2_mag_f', unit: '°C', label: 'Trafo Phase 2'},
        {name: 'WTRF1_TrfTmpPhase3_mag_f', unit: '°C', label: 'Trafo Phase 3'},
        {name: 'WCNV1_CnvTmpDclink_mag_f', unit: '°C', label: 'Converter Temp'},
        {name: 'WCNV1_CnvTmpWater_mag_f', unit: '°C', label: 'Converter Water Temp'},
        // overallParameters
        {name: 'WTRM1_GbxOilPres_mag_f', unit: 'Bar', label: 'Gearbox Oil Pressure'},
        {name: 'WROT1_RotSpd_mag_f', unit: 'rpm', label: 'Rotor Speed'},
        {name: 'WROT1_PtAngValBl1_mag_f', unit: 'deg', label: 'Pitch Angle Blade 1'},
        {name: 'WROT1_PtAngValBl2_mag_f', unit: 'deg', label: 'Pitch Angle Blade 2'},
        {name: 'WROT1_PtAngValBl3_mag_f', unit: 'deg', label: 'Pitch Angle Blade 3'},
        {name: 'WROT1_PtAngValAvg_mag_f', unit: 'deg', label: 'Pitch Angle Avg.'},
        {name: 'WROT1_PtHyPresBl1_mag_f', unit: 'Bar', label: 'Pitch Oil Pressure Blade 1'},
        {name: 'WROT1_PtHyPresBl2_mag_f', unit: 'Bar', label: 'Pitch Oil Pressure Blade 2'},
        {name: 'WROT1_PtHyPresBl3_mag_f', unit: 'Bar', label: 'Pitch Oil Pressure Blade 3'},
        {name: 'WROT1_PtHyPresAvg_mag_f', unit: 'Bar', label: 'Pitch Oil Pressure Avg.'},
        {name: 'WYAW1_BrkPres_mag_f', unit: 'Bar', label: 'Yaw Break Pressure'},
        {name: 'WTRM1_BrkHyPres_mag_f', unit: 'Bar', label: 'Shaft Brake Pressure'},
        {name: 'WYAW1_CabWup_mag_f', unit: 'rev', label: 'Cable Twist'},

        // ElectricParams
        {name: 'WTUR1_VAr_mag_f', unit: 'VAr', label: 'Reactive Power'},
        {name: 'MMXU1_Hz_mag_f', unit: 'Hz', label: 'Power Frequency'},
        {name: 'MMXU1_PhV_phsA_cVal_mag_f', unit: 'V', label: 'Voltage L1'},
        {name: 'MMXU1_PhV_phsB_cVal_mag_f', unit: 'V', label: 'Voltage L2'},
        {name: 'MMXU1_PhV_phsC_cVal_mag_f', unit: 'V', label: 'Voltage L3'},
        {name: 'MMXU1_A_phsA_cVal_mag_f', unit: 'A', label: 'Current L1'},
        {name: 'MMXU1_A_phsB_cVal_mag_f', unit: 'A', label: 'Current L2'},
        {name: 'MMXU1_A_phsC_cVal_mag_f', unit: 'A', label: 'Current L3'},
        {name: 'MMXU1_TotPF_mag_f', unit: '', label: 'Avr. Power Factor'},
        {name: 'WGEN1_Spd_mag_f', unit: 'rpm', label: 'Generator Speed'},

    ];

  transform(value: string, key: string): string {
    let signalFound = this.signalMapper.find(signal => signal.name === value);

    if (signalFound === undefined) {
        signalFound =  {unit: '-', label: '-', name: '-'};
    }

    return signalFound[key];
  }

}
